import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getMonthYear } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Batch No.',
    accessor: 'batch_no'
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Available Stock',
    accessor: 'bill_qty'
  }
];

export const AddProductDetailsForm = ({
  onClose,
  chargeType = 'opd_charges',
  doctorID,
  onAdd,
  editData,
  isEditMode,
  stock,
  setAddDetailsDialogOpen
}) => {
  const [input, setInput] = useState('');
  const [matchedData, setMatchedData] = useState([]);
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {},
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  useEffect(() => {
    if (stock?.data && editData?.product?._id) {
      const matched = stock.data.flatMap(
        (item) =>
          item.productDetails?.filter((productDetail) => productDetail.product?._id === editData.product._id) || []
      );
      setMatchedData(matched);
    }
  }, [stock, editData]);

  useEffect(() => {
    if (isEditMode && editData) {
      const formattedExpDate = editData.exp_date ? new Date(editData.exp_date).toISOString().slice(0, 7) : '';
      const rate = parseFloat(editData.mrp) || 0;
      const billQty = parseFloat(editData.bill_qty) || 0;
      const calculatedAmount = rate * billQty;
      reset({
        product_name: editData.product?.main?.name || '',
        rate: rate,
        bill_qty: billQty,
        amount: isNaN(calculatedAmount) ? 0 : calculatedAmount,
        batch_no: editData.batch_no || '',
        exp_date: formattedExpDate,
        gst: editData.gst || 0,
        hsn_code: editData.hsn_code || '',
        product: editData?.product?._id
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues
    };
    console.log('HELLLLO THE FORMVALUES IS HERE', formValues);
    onAdd(transformedValues);
    setAddDetailsDialogOpen(false);
  };

  const handleProductSelection = (row) => {
    console.log('CLICKED THE ROW', row);
    const formattedExpDate = row.exp_date ? new Date(row.exp_date).toISOString().slice(0, 7) : '';
    setValue('product_name', row.product?.main?.name);
    setValue('rate', row.rate);
    setValue('batch_no', row.batch_no);
    setValue('exp_date', formattedExpDate);
    setValue('hsn_code', row?.hsn_code);
    setValue('gst', row?.gst);
  };

  const rateWatch = watch('rate');
  const billQty = watch('bill_qty');

  useEffect(() => {
    setValue('amount', rateWatch * billQty);
  });

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Product Batch Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              data={matchedData || []}
              sx={{ fontSize: '32px' }}
              columns={TABLE_HEADER}
              onRowClick={handleProductSelection}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="product_name" placeholder="Product Name" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.8 }} name="rate" placeholder="Bill Qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                <TextField sx={{ flex: 0.8 }} name="bill_qty" placeholder="Bill Qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                <TextField sx={{ flex: 0.8 }} name="batch_no" placeholder="Batch No" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date/HSN Code</Typography>
                <TextField sx={{ flex: 0.4 }} name="exp_date" type="month" />
                <TextField sx={{ flex: 0.4 }} name="hsn_code" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                <TextField sx={{ flex: 0.8 }} name="gst" placeholder="GST %" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                <TextField sx={{ flex: 0.8 }} name="amount" placeholder="GST %" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
